import { useMutation } from 'react-query'
import { AxiosError } from 'axios'
import { reprocessRainforestEvent, ReprocessRainforestEventResult } from './rainforestEventsApi'

export const useReprocessRainforestEventMutation = () => {
  return useMutation<ReprocessRainforestEventResult, AxiosError, string>({
    mutationFn: (payload: string) => reprocessRainforestEvent(payload),
  })
}
